import { Burger, Wrapper } from './styles';

interface MenuProps {
  onClick?: () => void;
}
const Menu = ({ onClick }: MenuProps) => (
  <Wrapper onClick={onClick}>
    <Burger />
    <Burger />
    <Burger />
  </Wrapper>
);

export default Menu;
